import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';

export const CustomSlider = styled(Slider)({
    color: 'var(--profile-primary, #6025D8)',
    height: 8,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
        color: 'var(--profile-primary, #6025D8)',
    },
    '& .MuiSlider-valueLabel': {
        backgroundColor: 'white',
        color: 'black',
        transformOrigin: 'bottom left',
        '&:before': { display: 'none' },
        border: '2px solid var(--profile-primary, #6025D8)',
        borderRadius: '3px',
        fontWeight: 700,
    },
    '& .MuiSlider-rail': {
        color: 'var(--profile-primary-muted, rgba(96, 37, 216, 0.18))',
        opacity: 1,
    },
});
